export default __webpack_public_path__ + "static/demo-a04440f9417d71389bc99b298d561c68.gif";